<template>
    <el-dialog :title="title + '功能'" width="40%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <div class="el-table-container">
            <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading"
                     :disabled="method==='view'" @keyup.enter.native="doSubmit()" @submit.native.prevent>
                <el-form-item label="功能标识ID：" prop="metadataFonctionsId">
                    <el-select class="w100i" v-model="form.metadataFonctionsId" placeholder="请选择功能标识ID" clearable filterable :disabled="method!='add'" @change="fonctionsNumberChange">
                        <el-option
                                :key="item.id"
                                :label="item.fonctionsNumber +' '+ item.fonctionsName"
                                :value="item.id" :disabled="item.disabled"
                                v-for="item in fonctionsNumberOpt">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能名称：" prop="detailName">
                    <el-input v-model.trim="form.detailName" placeholder="请输入功能名称（限10字）" clearable maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="功能类型：" prop="detailType">
                    {{$dictUtils.getDictLabel("detailType", form.detailType ,'')}}
                </el-form-item>
                <el-form-item label="功能描述：" prop="detailDescription">
                    <el-input v-model.trim="form.detailDescription" type="textarea"
                              :rows="1" placeholder="请输入功能描述（限200字）" clearable maxlength="200" v-if="visible"></el-input>
                </el-form-item>
                <el-form-item label="图标：" prop="detailIcon">
                    <el-input v-model="form.detailIcon" placeholder="请选择" clearable @focus="selectIcon"></el-input>
                </el-form-item>
                <el-form-item label="启用状态：" prop="disabled">
                    <el-switch v-model="form.disabled" active-value="0" inactive-value="1" @change="enabledChange(form)"></el-switch>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{method == 'view' ? '关闭' : '取消'}}</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick v-if="method != 'view'">提交</el-button>
        </div>
        <Icon ref="icon" @getValue="value => form.detailIcon = value"></Icon>
    </el-dialog>
</template>

<script>
    import Icon from '@/components/icon'
    export default {
        components: { Icon },
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                form: {
                    metadataFonctionsId: '',
                    fonctionsNumber: '',
                    detailName: '',
                    detailType: '',
                    detailDescription: '',
                    detailIcon: '',
                    disabled: '0',
                },
                fonctionsNumberOpt: [],
                dataRule: {
                    metadataFonctionsId: [
                        {required: true, message: '功能标识ID不能为空', trigger: 'change'}
                    ],
                    detailName: [
                        {required: true, message: '功能名称不能为空', trigger: 'blur'}
                    ],
                    detailType: [
                        {required: true, message: '功能类型不能为空', trigger: 'change'}
                    ],
                },
                allData: [],
            }
        },
        methods: {
            init(row, method, allData) {
                this.getFonctionsNumber()
                this.method = method
                this.allData = allData
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    if (row) {
                        this.form = this.recover(this.form, row);
                    }
                })
            },
            // 获取功能标识ID
            getFonctionsNumber() {
                this.$axios(this.api.metadata.selectAll).then(data => {
                    if (data.status) {
                        this.fonctionsNumberOpt = data.data
                        this.fonctionsNumberOpt.map(opt => {
                            this.$set(opt, 'disabled', false)
                        })
                        let opts = this.fonctionsNumberOpt.filter(v => this.allData.some(d => d.metadataFonctionsId == v.id))
                        opts.map(item => {
                            this.$set(item, 'disabled', true)
                        })
                    }
                })
            },
            // 请选择功能标识
            fonctionsNumberChange(val) {
                this.form.detailType = ''
                this.form.detailName = ''
                let item = this.fonctionsNumberOpt.filter(v => v.id == val)[0]
                if(item) {
                    this.$set(this.form, 'detailType', item.detailType)
                    this.$set(this.form, 'detailName', item.fonctionsName)
                    this.$set(this.form, 'fonctionsNumber', item.fonctionsNumber)
                }
            },
            // 选择图标
            selectIcon() {
                this.$refs.icon.visible = true
            },
            // 启用状态
            enabledChange(row) {
                let str = '', state = null
                // 启用
                if(row.disabled == '0') {
                    state = '1'
                    str = '启用后，该按钮将显示在【业务功能配置管理】的“页面功能选择或"列表功能选择”中，支持被引用，是否启用？'
                } else {
                    state = '0'
                    str = '禁用后，系统将收回该按钮在【业务功能配置管理】的引用，且已设置的"状态变更设置"逻辑会同步删除，是否继续?'
                }
                this.$confirm(str, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                }).catch(action => {
                    this.$set(row, 'disabled', state)
                });

            },
            // 确定
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.visible = false
                        this.$emit('getDetailList', {
                            method: this.method,
                            form: JSON.parse(JSON.stringify(this.form))
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
</style>
